import { useEffect, useRef, useState } from 'react';
import { CaseType } from 'src/graphql';
import { AuditActions } from 'src/types';
import { useAuditEntry } from '../useAuditEntry';

export const useViewCaseAuditEntry = (id: string, caseData: CaseType) => {
  const { createAuditEntry, completeAuditEntry } = useAuditEntry();
  const [viewCaseAuditEntryID, setViewCaseAuditEntryID] = useState<number>();
  const completedRef = useRef(false);

  useEffect(() => {
    createAuditEntry(
      {
        auditAction: AuditActions.VIEW_CASE,
        auditData: {
          caseId: id,
        },
        completed: false,
      },
      {
        onSuccess: ({ createAuditEntry }) => {
          if (createAuditEntry?.id) {
            setViewCaseAuditEntryID(createAuditEntry.id);
          }
        },
      },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (caseData && viewCaseAuditEntryID && !completedRef.current) {
      completedRef.current = true;
      completeAuditEntry({ id: viewCaseAuditEntryID });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [caseData, viewCaseAuditEntryID]);
};
